<template>
  <div id="app">
    <b1t-okraina-header/> 
    <b1t-okraina-page-loader/>


    <keep-alive>
        <router-view></router-view>
    </keep-alive>

  </div>
</template>

<script>
  import b1tOkrainaHeader from './components/okraina/header'
  import b1tOkrainaPageLoader from './components/okraina/page-loader'

  export default {
    name: 'App',
    components: {
      b1tOkrainaHeader,
      b1tOkrainaPageLoader
    }
  }
</script>

<style>

</style>
